interface TestimonialCardProps {
  quote: string;
  name: string;
  title: string;
  image: string;
}

const TestimonialCard = ({ quote, name, title, image }: TestimonialCardProps) => (
  <section className="pb-20">
    <div className="container mx-auto px-4 max-w-6xl">
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_auto] gap-8 items-center">
        {/* Quote */}
        <div className="relative pl-12 md:pl-16">
          <span className="absolute left-0 top-0 text-primary text-6xl md:text-7xl font-display leading-none select-none">
            &ldquo;
          </span>
          <blockquote className="text-lg md:text-2xl font-display tracking-wide leading-relaxed uppercase mb-6">
            {quote}
          </blockquote>
          <p className="font-body font-semibold text-foreground">{name}</p>
          <p className="font-body text-sm text-muted-foreground">{title}</p>
        </div>

        {/* Image */}
        <div className="hidden lg:block w-64 xl:w-80 flex-shrink-0">
          <img
            src={image}
            alt={`${name}, ${title} — MyStudio client`}
            className="w-full h-auto object-cover"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </section>
);

export default TestimonialCard;
